export default "//cdn.scentbird.com/assets/frontbird-site/images/card-back@2x_c5bd8e.png";